import type { SVGProps } from 'react';
const SvgBowArrowSharpSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path d="M352 32 512 0l-32 160-47-47-249.2 249.1L200 416l-96 96-24-80-80-24 96-96 53.9 16.2L399 79zM192 64c47.7 0 95.4 13.2 137.1 39.7l-46.8 46.8c-28.1-15-59.2-22.5-90.3-22.5-29.9 0-58.3 10.2-85.8 28.9l84.8 84.9-45.2 45.2L25.4 166.6 2.7 144 48 98.7 60.3 111c38-28.1 81.6-47 131.7-47m169.5 165.7 46.8-46.8C434.8 224.6 448 272.3 448 320c0 50.1-18.9 93.7-47 131.7l12.3 12.3-45.3 45.3-22.6-22.6L225 366.2l45.2-45.2 84.8 84.8c18.8-27.5 29-55.9 29-85.8 0-31.1-7.5-62.2-22.5-90.3" />
  </svg>
);
export default SvgBowArrowSharpSolid;
